import { POWERED_BY_WINNIN_BASE64 } from 'assets/images/base64/powered-by-winnin'

export const DEFAULT_WINNIN_LOGO_CAPTION = `
  <img
    src="data:image/png;base64,${POWERED_BY_WINNIN_BASE64}"
    height="16"
    width="145"
    style="max-width: 100%; height: auto; display: block; margin-left: auto;"
    alt="Powered by Winnin"
  />
`
